import React from 'react'

export default function Error({ error }) {
  let finalMessage = ''

  if (!error) {
    return null
  }

  // client-side failures (nothing came back from Starbase) carry their own copy, since a
  // plain Error has no structured payload to extract and would otherwise fall through to
  // the generic message below
  if (error?.userMessage) {
    return <div className="invalid-feedback field-container">{error.userMessage}</div>
  }

  if (error?.response?.data?.errors) {
    error.response.data.errors.forEach(err => {
      finalMessage += `${err.message}\n`
    })
  }

  // guard: a thrown value may not carry a string `message` (e.g. a network error), so
  // optional-chain before calling indexOf to avoid throwing inside the error renderer
  const { message } = error

  if (error.response?.status === 401 || message?.indexOf('Access') === 0) {
    finalMessage = finalMessage || 'Sign in failed. Please try again or try resetting your password.'
  }

  // fall back to a generic message so an error without a structured payload (e.g. a network
  // error) still shows feedback rather than an empty container
  if (!finalMessage) {
    finalMessage = 'Something went wrong. Please try again.'
  }

  return <div className="invalid-feedback field-container">{finalMessage}</div>
}
